import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserProfile {
  id: string;
  email: string;
  name?: string;
  picture?: string;
  nickname?: string;
}

interface AuthState {
  userProfile: UserProfile | null;
  isLoading: boolean;
}

interface AuthActions {
  setUserProfile: (profile: UserProfile | null) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set) => ({
      userProfile: null,
      isLoading: false,

      setUserProfile: (userProfile: UserProfile | null) => {
        set({ userProfile });
      },

      setLoading: (isLoading: boolean) => {
        set({ isLoading });
      },

      clearAuth: () => {
        set({
          userProfile: null,
          isLoading: false,
        });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        userProfile: state.userProfile,
      }),
    },
  ),
);
